import { CamelToPascal } from "./types/CamelToPascal";

export function fromCamelToPascal<T>(model: T): CamelToPascal<T> {
    if (Array.isArray(model)) {
        const newModel = [];
        for (const item of model) {
            newModel.push(fromCamelToPascal(item));
        }

        return newModel as CamelToPascal<T>;
    }

    if (model === null || typeof model !== "object") {
        return model as CamelToPascal<T>;
    }

    const newModel: Record<string, unknown> = {};
    const entries = Object.entries(model);

    for (const [key, value] of entries) {
        const newKey = /^[a-z]/.test(key) ? key[0].toUpperCase() + key.slice(1) : key;
        newModel[newKey] = fromCamelToPascal(value);
    }

    return newModel as CamelToPascal<T>;
}
